export interface LibraryConfig {
  title: string;
  description: string;
  brandImage: string;
  backgroundColor: string;
}

export const LIBRARY_CONFIGS: Record<string, LibraryConfig> = {
  nextinvogue2024: {
    title: "Next In Vogue 2024",
    description:
      "Explore the latest trends and innovations in fashion technology",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/nextinvogue2024/images/nextinvoguelogo.png",
    backgroundColor:
      "radial-gradient(circle at 100%, #2A3E8A 0%, #64B445 100%)",
  },
  bemore2024: {
    title: "Be More 2024",
    description:
      "Personal development and growth strategies for the modern professional",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/bemore2024/images/669a8779d90d6d2480089811_Bemore+Logo.svg",
    backgroundColor:
      "radial-gradient(circle at 100%, #8c00f7 0%, #d7ec37 100%)",
  },
  "24fintech2024": {
    title: "24 FinTech 2024",
    description: "Cutting-edge financial technology insights and innovations",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/24fintech2024/images/logo.svg",
    backgroundColor:
      "radial-gradient(circle at 100%, #65b4f3 0%, #ef56fc 100%)",
  },
  aiewf2025: {
    title: "AI Engineer World's Fair 2025",
    description: "Cutting-edge technology insights and innovations",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/aiewf2025/images/logo.svg",
    backgroundColor: "radial-gradient(circle at 100%, #111 0%, #5EEAD4 100%)",
  },
  lorongaiwednesday2025: {
    title: "Lorong AI Wednesday",
    description: "AI Talks - yes, every Wednesdays",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/lorongaiwednesday2025/images/logo.svg",
    backgroundColor:
      "radial-gradient(circle at 100%, #F8F7F8 0%, #5EEAD4 100%)",
  },
  switch2025: {
    title: "Singapore Week of Innovation & Technology",
    description: "Asia's premier innovation festival",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/switch2025/images/logo.png",
    backgroundColor:
      "radial-gradient(circle at 100%, #F4333D 0%, #FFFFFF 100%)",
  },
  wtf2025: {
    title: "West Tech Fest",
    description: "Australia's longest running tech and innovation festival",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/wtf2025/images/logo.svg",
    backgroundColor:
      "radial-gradient(circle at 100%, #FFFFFF 0%, #FF6123 100%)",
  },
  scalablehci2026: {
    title: "Scalable HCI 2025",
    description:
      "Where Human-Computer Interaction Meets Open Hardware at Global Scale",
    brandImage:
      "https://thoth-weblibrary.s3.ap-southeast-1.amazonaws.com/scalablehci2026/images/logo.svg",
    backgroundColor:
      "radial-gradient(circle at 100%, #FFFFFF 0%, #000000 100%)",
  },
};

// Extract just the titles for use in router
export const EVENT_TITLES: Record<string, string> = Object.fromEntries(
  Object.entries(LIBRARY_CONFIGS).map(([key, config]) => [key, config.title])
);

export const WEB_LIBRARY_ROUTES = [
  "WebLibraryHome",
  "StagePage",
  "TalkPage",
  "DayPage",
  "SearchResultsPage",
  "AgendaPage",
  "AboutPage",
  "LikeInfographics",
];
